import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { LiteratureLibrary } from '../../Models/Models/Documents/LiteratureLibrary';
import { Category } from '../../Constants/Enums/Documents/Category';

declare var IS_RUNNING_IN_APP_POOL;

export class LiteratureLibraryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(search: string, category: Category, isFavourite: boolean): Promise<Array<LiteratureLibrary>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/LiteratureLibrary/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { search: search, category: category, isFavourite: isFavourite }

    return AjaxWrapper.get<Array<LiteratureLibrary>, any>(url, data);
  }
  public put(documentId: number, isFavourite: boolean): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/LiteratureLibrary/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { documentId: documentId, isFavourite: isFavourite }

    return AjaxWrapper.put<string, any>(url, data);
  }
}

